import PermissionButton from '../../permissions/PermissionButton';
import React, { useState, useRef } from 'react';
import { Table, Input, Button, Space, Card, Drawer } from 'antd';
import { SearchOutlined, PlusOutlined } from '@ant-design/icons';
import { useFetchAllComs } from '../../hooks/comHooks';
import ComForm from './ComForm';
const ComList = ({ onSelectCom }) => {
    const { Coms, loading, error, refetch } = useFetchAllComs(); // Assuming 'Coms' is the correct state variable name
    const searchInput = useRef(null);
    const [isCreateOpen, setIsCreateOpen] = useState(false);
    
    // Search states
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    
    // Search and filtering function for 'nom'
    const getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={searchInput}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) => record[dataIndex] ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()) : '',
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => searchInput.current && searchInput.current.select());
            }
        },
        render: text => searchedColumn === dataIndex ? (
            <span style={{ backgroundColor: searchedColumn === dataIndex && searchText ? '#ffc069' : '' }}>
                {text}
            </span>
        ) : text
    });

    // Handling search and reset
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
    };

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error}</p>;

    const columns = [
        {
            title: 'Code',
            dataIndex: 'code_com',
            key: 'code_com',
        },
        {
            title: 'Name',
            dataIndex: 'nom',
            key: 'nom',
            ...getColumnSearchProps('nom'),
        },
        {
            title: 'Telephone',
            dataIndex: 'tel',
            key: 'tel',
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
    ];
    const titleStyle = {
        fontSize: "24px", // Increased font size for titles
        fontWeight: "bold",
        color: "#333", // Darker font color for better visibility
        marginBottom: "16px",
        borderBottom: "2px solid #ccc", // Separator line
        paddingBottom: "10px", // Spacing between title and separator line
        marginTop: "-10px",
      };
      
      
      const tableCardStyle = {
        marginTop: "20px",
        backgroundColor: "#ffffff", // Lighter than the main background for emphasis
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)", // Optional: adds subtle shadow for depth
      };
      const mainBackgroundStyle = {
        background: "#ececec", // Main background color
        padding: "20px",
      };

    const handleCreated = () => {
        setIsCreateOpen(false);
        refetch && refetch();
    };

    return (
        <div >
           <Card style={tableCardStyle}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 12 }}>
        <h2 style={titleStyle}>Commercial List</h2>
        <PermissionButton permissionModule="commercials" permissionAction="create" type="primary" icon={<PlusOutlined />} onClick={() => setIsCreateOpen(true)}>
            Ajouter
        </PermissionButton>
        </div>
         <Table
                columns={columns}
                dataSource={Coms}
                rowKey="code_com"
                pagination={{ pageSize: 10 }}
                onRow={(record) => ({
                    onClick: () => onSelectCom(record.code_com),
                })}
            />
            </Card>
            <Drawer
                title="Nouveau commercial"
                placement="right"
                width={480}
                open={isCreateOpen}
                onClose={() => setIsCreateOpen(false)}
                destroyOnClose
            >
                <ComForm onSuccess={handleCreated} />
            </Drawer>
        </div>
    );
};

export default ComList;
